import * as React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useBexApi } from '@shared-ui/bex-api-context';
import { UitkFavoriteSwitch } from 'uitk-react-switch';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m)
        return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
    }
    catch (error) {
        e = { error: error };
    }
    finally {
        try {
            if (r && !r.done && (m = i["return"]))
                m.call(i);
        }
        finally {
            if (e)
                throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages.
 */
var AlterMode;
(function (AlterMode) {
    AlterMode["DEBUG"] = "DEBUG";
    AlterMode["NONE"] = "NONE";
    AlterMode["PREVIEW"] = "PREVIEW";
    AlterMode["RELEASED"] = "RELEASED";
})(AlterMode || (AlterMode = {}));
var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState["ANONYMOUS"] = "ANONYMOUS";
    AuthenticationState["AUTHENTICATED"] = "AUTHENTICATED";
    AuthenticationState["IDENTIFIED"] = "IDENTIFIED";
})(AuthenticationState || (AuthenticationState = {}));
/**
 * Valid device types
 */
var DeviceType;
(function (DeviceType) {
    DeviceType["APP_PHONE"] = "APP_PHONE";
    DeviceType["APP_TABLET"] = "APP_TABLET";
    DeviceType["CHAT_APP"] = "CHAT_APP";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
    DeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
    DeviceType["VOICE_APP"] = "VOICE_APP";
})(DeviceType || (DeviceType = {}));
/**
 * Privacy tracking user preference. We can retrieve info on if the site allows
 * tracking from Site Info and null can also be used to represent a selection or not
 */
var PrivacyTrackingState;
(function (PrivacyTrackingState) {
    PrivacyTrackingState["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
    PrivacyTrackingState["CAN_TRACK"] = "CAN_TRACK";
})(PrivacyTrackingState || (PrivacyTrackingState = {}));
var ProductType;
(function (ProductType) {
    ProductType["ARTICLE"] = "ARTICLE";
    ProductType["CAR_DETAILS"] = "CAR_DETAILS";
    ProductType["DESTINATION"] = "DESTINATION";
    ProductType["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
    ProductType["EXPERIENCE"] = "EXPERIENCE";
    ProductType["EXPERT_TIP"] = "EXPERT_TIP";
    ProductType["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
    ProductType["LX_DETAILS"] = "LX_DETAILS";
    ProductType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    ProductType["POI_GAIA"] = "POI_GAIA";
    ProductType["PROPERTY_DETAILS"] = "PROPERTY_DETAILS";
})(ProductType || (ProductType = {}));
var Result;
(function (Result) {
    Result["ERROR"] = "ERROR";
    Result["SUCCESS"] = "SUCCESS";
})(Result || (Result = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

/**
 * @protected
 */
var defaults = {
    /**
     * foo
     */
    dispatchHandler: function () {
        /* noop */
    }
};
/**
 * Internal context object to create provider/consumer.
 * @protected
 */
var ShortlistToggleContext = React.createContext(defaults);
/**
 * Provider component for setting up custom higher level behavior when shortlist toggle is clicked.
 *
 * @example
 * const MyApp: React.FC = (props) => {
 *  const { children } = props;
 *  const shortlistDispatchHandler = ({ message }) => console.log(`[shortlist] ${message}`);
 *
 *  return (
 *    <div>
 *      <SomeProvider>
 *        <ShortlistToggleProvider dispatchHandler={shortlistDispatchHandler}>
 *          {children}
 *        </ShortlistToggleProvider>
 *      <SomeProvider>
 *    </div>
 *  );
 * }
 */
var ShortlistToggleProvider = function (props) {
    var children = props.children, dispatchHandler = props.dispatchHandler;
    var value = { dispatchHandler: dispatchHandler };
    return React.createElement(ShortlistToggleContext.Provider, { value: value }, children || null);
};
/**
 * Convenient hook to get access to the dispatch method needed for passing events up to the provider.
 *
 * @protected
 */
var useShortlistToggle = function () {
    var dispatchHandler = React.useContext(ShortlistToggleContext).dispatchHandler;
    return {
        toggleDispatch: dispatchHandler
    };
};

var MutationRemoveShortlistItem = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "RemoveShortlistItem" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ContextInput" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ProductType" } } }, "defaultValue": undefined, "directives": [] }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "removeShortlistItem" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "context" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "productId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "productType" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productType" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "result" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 226, "source": { "body": "\n  mutation RemoveShortlistItem($context: ContextInput!, $productId: String!, $productType: ProductType!) {\n    removeShortlistItem(context: $context, productId: $productId, productType: $productType) {\n      result\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var MutationSaveShortlistItem = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "SaveShortlistItem" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ContextInput" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ProductType" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "metadata" } }, "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ShortlistMetadataInput" } } } }, "defaultValue": undefined, "directives": [] }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "saveShortlistItem" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "context" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "productId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "productType" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productType" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "metadata" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "productId" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "productType" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 311, "source": { "body": "\n  mutation SaveShortlistItem($context: ContextInput!, $productId: String!, $productType: ProductType!, $metadata: [ShortlistMetadataInput!]) {\n    saveShortlistItem(context: $context, productId: $productId, productType: $productType, metadata: $metadata) {\n      id\n      productId\n      productType\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var LocalStateQuery = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "LocalShortlistedItems" }, "variableDefinitions": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "localShortlistedItems" }, "arguments": [], "directives": [{ "kind": "Directive", "name": { "kind": "Name", "value": "client" }, "arguments": [] }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "productType" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "isShortlisted" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 143, "source": { "body": "\n  query LocalShortlistedItems {\n    localShortlistedItems @client {\n      id\n      productType\n      isShortlisted\n      __typename\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var optimisticRemoveResponse = function () { return ({
    removeShortlistItem: {
        __typename: 'RemoveItemResults',
        result: Result.SUCCESS
    }
}); };
var optimisticSaveResponse = function (productId, productType) { return ({
    saveShortlistItem: {
        __typename: 'SavedItem',
        id: "temp-" + productId,
        productId: productId,
        productType: productType
    }
}); };
var ShortlistToggle = function (props) {
    var _a, _b, _c;
    var onChange = props.onChange, _d = props.initialChecked, initialChecked = _d === void 0 ? false : _d, inputs = props.inputs, label = props.label;
    var context = useBexApi().context;
    var toggleDispatch = useShortlistToggle().toggleDispatch;
    var metadata = inputs.metadata, productId = inputs.productId, productType = inputs.productType;
    var variables = {
        context: context,
        metadata: metadata,
        productId: productId,
        productType: productType
    };
    var _e = __read(React.useState(productId + "-" + productType), 2), id = _e[0], setId = _e[1];
    var localShortlists = useQuery(LocalStateQuery).data;
    var hasLocalState = (_a = localShortlists === null || localShortlists === void 0 ? void 0 : localShortlists.localShortlistedItems) === null || _a === void 0 ? void 0 : _a.find(function (shortlist) { return shortlist.id === productId; });
    var isShortlisted = hasLocalState
        ? Boolean((_c = (_b = localShortlists === null || localShortlists === void 0 ? void 0 : localShortlists.localShortlistedItems) === null || _b === void 0 ? void 0 : _b.find(function (localShortlist) { return localShortlist.id === productId; })) === null || _c === void 0 ? void 0 : _c.isShortlisted)
        : initialChecked;
    var _f = __read(useMutation(isShortlisted ? MutationRemoveShortlistItem : MutationSaveShortlistItem, {
        optimisticResponse: isShortlisted ? optimisticRemoveResponse() : optimisticSaveResponse(productId, productType),
        update: function (cache) {
            var _a;
            var updatedEntry = {
                __typename: 'LocalShortlistedItem',
                id: productId,
                productType: productType,
                isShortlisted: !isShortlisted
            };
            var items;
            // readQuery will fail the first time when localShortlistedItems field doesn't exists in the cache
            try {
                var cachedEntries = cache.readQuery({ query: LocalStateQuery });
                // Keep all unrelated entries
                items = ((_a = cachedEntries === null || cachedEntries === void 0 ? void 0 : cachedEntries.localShortlistedItems) === null || _a === void 0 ? void 0 : _a.filter(function (entry) { return entry.id !== productId; })) || [];
            }
            catch (_b) {
                items = [];
            }
            // Append the new entry
            cache.writeQuery({ query: LocalStateQuery, data: { localShortlistedItems: __spreadArray(__spreadArray([], __read(items), false), [updatedEntry], false) } });
        }
    }), 1), saveOrRemove = _f[0];
    // The id must be unique, we can't rely only on `prodcutId` because there may be more than
    // one toggle for the same product on a given page.
    // We don't set a random id during SSR, else there will be a mismatch during hydration
    // and React will throw away the existing nodes and re-create them.
    React.useEffect(function () {
        setId(Math.random().toString(36).substr(2, 5));
    }, [setId]);
    return (React.createElement(UitkFavoriteSwitch, { label: label || '', checked: isShortlisted, id: "heart-button-" + id, onChange: function () {
            saveOrRemove({ variables: variables });
            if (onChange && typeof onChange === 'function') {
                onChange(isShortlisted, !isShortlisted, toggleDispatch);
            }
        } }));
};

export { ProductType, ShortlistToggle, ShortlistToggleProvider };
